import {cloneDeep, isEmpty} from "lodash";
import WidgetOptions from "../Widgets/WidgetOptions";
import i18n from "@/plugins/i18n";
import {getTranslatedParams} from "@/utils/notify-utils";
export default {
  components: { WidgetOptions },
  data() {
    return {
      // options:{}
    };
  },
  methods: {
    saveOptions() {
      this.value.options = this.options;
      this.value.ShowOptions = false;
      this.$emit("input", this.value);
      const widgets = JSON.parse(localStorage.getItem('DashboardWidgetsWings'));
      const editedWidget = widgets.find(item => item.id === this.value.id);
      const isCreation = isEmpty(editedWidget.options);
      this.$store.dispatch('actionLog', this.getAdditionalInfo(isCreation ? "Creation" : "Editing"));
    },
    updateTitle() {
      this.$set(this.value, "title", this.title());
      this.$emit("input", this.value);
    },
    removeWidget(){
      this.$store.dispatch('actionLog', this.getAdditionalInfo("Removal"));
    },
    openFullSizeView(){
      this.$store.dispatch('actionLog', this.getAdditionalInfo("Viewing"));
    },

    getAdditionalInfo(action){
      let additionalInfo = {
        widget_type: this.getTranslatedName(this.value.name),
        'widget.options.update': this.value.options.update,
        'widget.options.track': this.getTranslatedValue(this.value.options.track),
        'widget.options.interval': this.getTranslatedValue(this.value.options.interval),
        'widget.options.chanel': this.value.options.chanel,
        'widget.options.group_by': this.getTranslatedGroupBy(this.value.options.group_by),
      };
      return {
        action_page: this.$route.meta.msgKey,
        action: action,
        action_status: 'success',
        object_type: "Widget",
        addititional_info: getTranslatedParams(additionalInfo)
      };
    },

    getTranslatedName(name){
      return `${i18n.t(`widget.${name}.name`,'ru')} / ${i18n.t(`widget.${name}.name`,'en')}`;
    },

    getTranslatedValue(value){
      if (value)
        return `${i18n.t(`widget.options.${value}`,'ru')} / ${i18n.t(`widget.options.${value}`,'en')}`;
    },

    getTranslatedGroupBy(value){
      if (value)
        return `${i18n.t(`widget.MessagesByGroup.options.group_by.${value}`,'ru')} / ${i18n.t(`widget.MessagesByGroup.options.group_by.${value}`,'en')}`;
    }
  },
  watch: {
    "value.options": {
      deep: true,
      immediate: true,
      handler(value) {
        if (Object.keys(this.value.options).length) {
          this.options = cloneDeep(this.value.options);
        }

        this.$set(this.value, "title", this.title());
        this.$emit("input", this.value);
      },
    },
  },
};
